import { MOBILE_BREAKPOINT_THRESHOLD, SxProps } from '@cp/ds/src/theme';
export * from './events';

export const contentContanerSx: SxProps = {
  px: { [MOBILE_BREAKPOINT_THRESHOLD]: 5 },
  minWidth: { [MOBILE_BREAKPOINT_THRESHOLD]: 495 },
};
